import clean from "./clean";

export default {
  ...clean,
  scene: {
    shader: "Med2",
    background: "./images/w11.jpg",
    shader_speed: 0.8,
    shader_opacity: 0.15,
    shader_zoom: 0.9,
    shader_sin_cos_x: true,
    shader_sin_cos_y: true,
    shader_sin_cos_speed: 0.5,
    shader_sin_cos_space: 55,
    blur: 2,
    brightness: 5,
    bgColor: "#000000",
    sparks: false,
  },
  timer: {
    opacity: 0.25,
  },
  vumeters: {
    oscilloscop: {
      color: "#FFFF22",
      show: true,
      opacity: 1,
      motionBlur: true,
      motionBlurLength: 0.15,
      z: -300,
    },
  },
  composer: {
    bloom: { show: true, strength: 0.32, threshold: 0.19, radius: 0.2 },
    film: { show: false },
    static: { show: false },
    rgb: { show: false },
    hue: { show: false },
  },
  texts: {
    title: {
      show: true,
      order: 5,
      text: "Analogik",
      font: "Lobster",
      x: 0,
      y: 130,
      z: -650,
      rotationX: 0,
      rotationY: 0,
      rotationZ: 0,
      size: 150,
      color: "#ff5555",
    },
    subtitle: {
      show: true,
      order: 5,
      text: "Chiptune netlabel",
      font: "Kdam Thmor Pro",
      x: -70,
      y: -19,
      z: -650,
      rotationX: 0,
      rotationY: 0,
      rotationZ: 0,
      size: 39,
      color: "#3e3e3e",
    },
  },
};
